import React from "react"
import ListenNow from "../components/ListenNow";

function Listen() {
  return (
    <div>
      <ListenNow />
    </div>
  )
};

export default Listen;
